import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["customFonts", "defaultFonts", "enableParsedFonts", "fetchBrandingCustomFonts", "parsedFonts", "parsedFontText", "unsupportedFonts", "value", "webfonts"];
import I18n from 'I18n';
//@ts-expect-error untyped module
import withDisabledContext from '../../hoc/withDisabledContext';
import { useState, useEffect, useMemo } from 'react';
//@ts-expect-error untyped module
import GroupedFontSelectBody from './GroupedFontSelectBody';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.formatting.FontSelect.${suffix}`;
function GroupedFontSelect(_ref) {
  let {
      customFonts = [],
      defaultFonts,
      enableParsedFonts = false,
      fetchBrandingCustomFonts,
      parsedFonts = [],
      parsedFontText,
      unsupportedFonts = [],
      value,
      webfonts = []
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [formattedBrandingFonts, setFormattedBrandingFonts] = useState([]);
  useEffect(() => {
    if (fetchBrandingCustomFonts && !formattedBrandingFonts.length) {
      fetchBrandingCustomFonts().then(fonts => {
        const formattedFonts = fonts.map(font => {
          return {
            fontSet: 'BRANDING',
            family: font.name,
            fallback: font.fallback,
            text: font.name,
            value: font.name,
            variants: font.variants.map(variant => variant.name),
            svgUrls: font.variants.reduce((hash, variant) => {
              hash[variant.name] = variant.svgUrl || '';
              return hash;
            }, {}),
            styles: font.variants.reduce((hash, variant) => {
              let variantStyles = {};
              try {
                variantStyles = JSON.parse(variant.style);
              } catch (e) {
                console.error(e);
              }
              hash[variant.name] = variantStyles;
              return hash;
            }, {})
          };
        });
        setFormattedBrandingFonts(formattedFonts);
      }).catch(error => {
        console.error(error);
        setFormattedBrandingFonts([]);
      });
    }
    // we just want this to run on init, not everytime tinymce renders, so removing deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const isUnsupportedFont = unsupportedFonts.includes(value || '');
  const options = useMemo(() => {
    const webFontOptions = webfonts.length ? [{
      text: I18n.text(i18nKey('webfontTitle')),
      help: I18n.text(i18nKey('webfontTooltip')),
      options: webfonts
    }] : [];
    const parsedFontOptions = parsedFonts.length && parsedFontText ? [{
      text: parsedFontText.text,
      help: parsedFontText.help,
      options: parsedFonts.map(({
        text,
        value: font_value
      }) => ({
        text,
        value: font_value,
        disabled: !enableParsedFonts
      }))
    }] : [];
    const combinedCustomFonts = [...customFonts, ...formattedBrandingFonts];
    const parsedCustomFontOptions = combinedCustomFonts.length ? [{
      text: I18n.text(i18nKey('customFontsTitle')),
      options: combinedCustomFonts.map(fontOption => ({
        family: fontOption.family,
        fallback: fontOption.fallback,
        fontSet: fontOption.fontSet || 'CUSTOM',
        text: fontOption.family,
        value: fontOption.value,
        variants: fontOption.variants,
        svgUrls: fontOption.svgUrls,
        styles: fontOption.styles
      }))
    }] : [];
    return [...parsedCustomFontOptions, ...defaultFonts, ...parsedFontOptions, ...webFontOptions];
  }, [formattedBrandingFonts, customFonts, defaultFonts, enableParsedFonts, parsedFonts, parsedFontText, webfonts]);
  return /*#__PURE__*/_jsx(GroupedFontSelectBody, Object.assign({}, rest, {
    error: isUnsupportedFont,
    fontOptions: options,
    value: value
  }));
}
export default withDisabledContext(GroupedFontSelect);